import React, { FC } from 'react'
import useOnScreen from '../../../hooks/use-on-screen'
import { TExtendedPostAttachment } from '../../../store/managePost/newTypes'

import './VideoPreview.scss'

interface VideoPreviewProps {
  attachment: TExtendedPostAttachment
  className?: string
  width: number
  onLoad?: () => void
}

const VideoPreview: FC<VideoPreviewProps> = ({
  attachment,
  className,
  width,
  onLoad = () => {}
}) => {
  const [isLoaded, setIsLoaded] = React.useState(false)
  const videoRef = React.useRef<HTMLVideoElement | null>(null)
  const containerRef = React.useRef<HTMLDivElement | null>(null)
  const isVisible = useOnScreen(containerRef)

  React.useEffect(() => {
    if (!isVisible || isLoaded) {
      return
    }
    if (videoRef.current) {
      videoRef.current.onloadeddata = () => {
        setIsLoaded(true)
        onLoad()
      }
    }
  }, [isVisible, onLoad, isLoaded])

  const videoThumbnail =
    attachment.thumbnail_object_data?.previews?.original ||
    attachment.thumbnail_object_data?.previews?.medium ||
    attachment.thumbnail_object_data?.previews?.small

  const videoHeight = attachment.object_data?.options.height
  const videoWidth = attachment.object_data?.options.width

  let calculatedHeight

  if (videoHeight && videoWidth && width) {
    const sizeProportion = videoHeight / videoWidth
    calculatedHeight = sizeProportion * width
  }

  return (
    <div
      ref={containerRef}
      className={`loadable-container light ${isLoaded && 'loaded'}`}
      style={{ height: calculatedHeight && calculatedHeight > width ? width : calculatedHeight }}
    >
      {(isVisible || isLoaded) && (
        <div className={`video-preview-wrapper ${isLoaded && 'loaded'}`}>
          <video
            ref={videoRef}
            poster={videoThumbnail || ''}
            height={calculatedHeight && calculatedHeight > width ? width : calculatedHeight}
            key={`video-attachment-${attachment.id}-${attachment.object_id}`}
            className={`video-preview ${isLoaded && 'loaded'} ${className}`}
            controls
          >
            <source src={attachment?.object_data?.public_url} />
          </video>
        </div>
      )}
    </div>
  )
}

export default VideoPreview
